import { render, staticRenderFns } from "./basicList.vue?vue&type=template&id=e246d7d2&scoped=true"
import script from "./basicList.vue?vue&type=script&lang=js"
export * from "./basicList.vue?vue&type=script&lang=js"
import style0 from "./basicList.vue?vue&type=style&index=0&id=e246d7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e246d7d2",
  null
  
)

export default component.exports